/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfOrderFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfOrder } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}/redemptions
 */
export interface RedemptionsRequestBuilder extends BaseRequestBuilder<RedemptionsRequestBuilder> {
    /**
     * The order is the redemption ledger: every order carries the promotions that applied to it at checkout, so this is the orders holding any of the campaign's promotions, newest first. Each order's appliedPromotions says which promotion, which code and how much.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfOrder>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<RedemptionsRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfOrder | undefined>;
    /**
     * The order is the redemption ledger: every order carries the promotions that applied to it at checkout, so this is the orders holding any of the campaign's promotions, newest first. Each order's appliedPromotions says which promotion, which code and how much.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<RedemptionsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * The order is the redemption ledger: every order carries the promotions that applied to it at checkout, so this is the orders holding any of the campaign's promotions, newest first. Each order's appliedPromotions says which promotion, which code and how much.
 */
export interface RedemptionsRequestBuilderGetQueryParameters {
    pageNumber?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const RedemptionsRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}/redemptions?pageNumber={pageNumber}&pageSize={pageSize}";
/**
 * Metadata for all the requests in the request builder.
 */
export const RedemptionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: RedemptionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfOrderFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
